export default __webpack_public_path__ + "static/media/zero-transaction-fees.4901a3b0.png";